export const filterPosts = (a, f) => {
  let filteredPosts;
  if (f.value === "all") {
    filteredPosts = a;
  } else if (Array.isArray(f.value)) {
    // If tag is an array, check if post has any of the tags in the array
    filteredPosts = a.filter((post) =>
      f.value.some((t) =>
        post.tags.nodes.some((postTag) => postTag.slug === t.toLowerCase())
      )
    );
  } else {
    filteredPosts = a.filter((post) =>
      post.tags.nodes.some((t) => t.slug === f.value)
    );
  }
  return filteredPosts;
};

export const filterPostsByTags = (posts, tags) => {
  return posts.filter((post) =>
    tags.every((tag) => {
      if (Array.isArray(tag)) {
        // If tag is an array, check if post has any of the tags in the array
        return tag.some((t) =>
          post.tags.nodes.some(
            (postTag) => postTag.name.toLowerCase() === t.toLowerCase()
          )
        );
      } else {
        // If tag is a string, use the existing logic
        return post.tags.nodes.some(
          (postTag) => postTag.name.toLowerCase() === tag.toLowerCase()
        );
      }
    })
  );
};
